module.exports = __webpack_public_path__ + "img/5-light.21247e81.png";